"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var Icons = _interopRequireWildcard(require("../../Icons"));
var _FilePage = _interopRequireDefault(require("./FilePage"));
require("./FileViewer.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FileViewer = function FileViewer(_ref) {
  var _fileList$current;
  var _ref$files = _ref.files,
    files = _ref$files === void 0 ? [] : _ref$files;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    fileList = _useState4[0],
    setFileList = _useState4[1];
  var increaseCurrent = (0, _react.useCallback)(function () {
    if (current === files.length - 1) return false;
    setCurrent(current + 1);
  }, [current, files]);
  var decreaseCurrent = (0, _react.useCallback)(function () {
    if (current === 0) return false;
    setCurrent(current - 1);
  }, [current]);
  (0, _react.useEffect)(function () {
    if (files) {
      var filesWithId = files.map(function (file, index) {
        if ((0, _isObject2["default"])(file)) {
          return _objectSpread(_objectSpread({}, file), {}, {
            id: index
          });
        }
        return {
          file: file,
          id: index
        };
      });
      setFileList(filesWithId);
    }
  }, [files]);
  var currentTitle = (_fileList$current = fileList[current]) === null || _fileList$current === void 0 ? void 0 : _fileList$current.title;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fileList && /*#__PURE__*/_react["default"].createElement("div", {
    className: "FileViewer"
  }, fileList.map(function (_ref2, index) {
    var file = _ref2.file,
      id = _ref2.id;
    return /*#__PURE__*/_react["default"].createElement(_FilePage["default"], {
      key: id,
      url: file,
      index: index,
      currentIndex: current
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ViewerControls"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    onClick: decreaseCurrent,
    onKeyDown: decreaseCurrent,
    tabIndex: "0",
    role: "button",
    className: "ViewerControls__controls"
  }, current !== 0 && /*#__PURE__*/_react["default"].createElement(Icons.ChevronLeft, {
    width: "1.5rem",
    height: "1.5rem"
  })), currentTitle && /*#__PURE__*/_react["default"].createElement("h6", {
    className: "mt-1 mb-3 text-uppercase"
  }, currentTitle), /*#__PURE__*/_react["default"].createElement("span", {
    onClick: increaseCurrent,
    onKeyDown: increaseCurrent,
    tabIndex: "0",
    role: "button",
    className: "ViewerControls__controls"
  }, current !== files.length - 1 && /*#__PURE__*/_react["default"].createElement(Icons.ChevronRight, {
    width: "1.5rem",
    height: "1.5rem"
  }))));
};
FileViewer.propTypes = {
  files: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]))
};
var _default = exports["default"] = FileViewer;